import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import ConfigProvider from "antd/es/config-provider";
import { Routes } from "routes";
import { FloatButton, theme } from "antd";
import { Color, ThemeProvider } from "shared/hooks/useThemeContent";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { BgColorsOutlined, FormatPainterOutlined } from "@ant-design/icons";
import {useNavigate} from "react-router-dom";
import {setNavigate} from "./utils/services/http-client";

const CustomFloatButton = styled(FloatButton.Group)`
  ant-float-btn .ant-float-btn-body .ant-float-btn-content .ant-float-btn-icon {
    width: unset !important;
  }
`;
const CircleIndigo = styled(FloatButton)`
  .ant-float-btn-body {
    background: linear-gradient(to right, #020D4D 50%, #020D4D 50%);
  }
`;
const CirclePeach = styled(FloatButton)`
  .ant-float-btn-body {
    background: linear-gradient(to right, #ff856c 50%, #ffbe98 50%);
  }
`;
const CirclePersianBlue = styled(FloatButton)`
  .ant-float-btn-body {
    background: linear-gradient(to right, #57c5c6 50%, #006566 50%);
  }
`;

function App() {
  document.title = "پیدا";

  const [colors, setTheme] = useState<Color>({
    primaryColor: null,
    secondColor: null,
  });

  useEffect(() => {
    let theme = localStorage.getItem("theme");
    theme ? setTheme(JSON.parse(theme)) : _setTheme("#6610f2", "#6f42c1b8", "#0066FF", "#DEEAF0","#f4e6ff")
    ;
  }, []);
  const navigate = useNavigate();

  const _setTheme = (
    primaryColor: string,
    sideBarColor: string,
    thirdColor?: string,
    forthColor?: string,
    fifthColor?: string
  ) => {
    let theme: Color = {
      primaryColor: primaryColor,
      secondColor: sideBarColor,
      thirdColor: thirdColor,
      forthColor: forthColor,
      fifthColor: fifthColor,
    };
    localStorage.setItem("theme", JSON.stringify(theme));
    setTheme({
      primaryColor: primaryColor,
      secondColor: sideBarColor,
      thirdColor: thirdColor,
      forthColor: forthColor,
      fifthColor: fifthColor,
    });
  };
  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);
  return (
    <>
      <ThemeProvider setTheme={setTheme} colors={colors}>
        <ConfigProvider
          direction="rtl"
          theme={{
            token: {
              colorPrimary:"#020D4D",
            },
          }}
        >
          <Routes isAuthorized={localStorage.getItem("jwt")} />
        </ConfigProvider>
      </ThemeProvider>
    </>
  );
}

export default App;
